import { NIVEAUX, niveau, PROBABILITES, IMPACTS } from './niveaux';

// Matrice 4 × 4 : nombre de risques par case (probabilité en lignes, impact en colonnes)
export const MatriceRisques = ({ items }) => (
  <div className="rounded-2xl border border-slate-200 bg-white p-4" data-testid="risques-matrice">
    <p className="mb-3 text-xs font-semibold uppercase tracking-wide text-slate-500">Matrice probabilité × impact</p>
    <div className="grid grid-cols-[auto_repeat(4,minmax(0,1fr))] gap-1 text-[10px] sm:text-xs">
      <span />
      {IMPACTS.map((l) => <span key={l} className="text-center font-medium text-slate-500">{l}</span>)}
      {[4, 3, 2, 1].map((p) => [
        <span key={`l${p}`} className="flex items-center pr-1 font-medium text-slate-500">{PROBABILITES[p - 1]}</span>,
        ...[1, 2, 3, 4].map((i) => {
          const n = items.filter((r) => r.probabilite === p && r.impact === i).length;
          return (
            <span key={`${p}-${i}`} className={`flex h-9 items-center justify-center rounded-md font-bold text-white ${NIVEAUX[niveau(p, i)].case} ${n ? '' : 'opacity-25'}`} data-testid={`matrice-${p}-${i}`}>
              {n || ''}
            </span>
          );
        }),
      ])}
    </div>
  </div>
);
